import React from "react";
import CookiesInfoComponent from "../../components/cookies/cookies-info";

const CookiesModal = ({ open, onClose }) => {
  const rejectCookies = () => {
    document.cookie = "_dd_s" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    onClose();
  };

  return <CookiesInfoComponent open={open} onClose={onClose} rejectCookies={rejectCookies} />;
};

export default CookiesModal;
